import { useMemo } from "react"
import { useRequiredLoggedInEmployee } from "~Shared/context/loggedInEmployee.context"
import { useAuth } from "~Shared/hooks/auth.hooks"

export const useLoggedInEmployeeProfile = useRequiredLoggedInEmployee

export const useActiveCompanyProfile = () => {
    const { companyId } = useAuth()

    const loggedInEmployee = useRequiredLoggedInEmployee()

    /**
     * sync active companyProfile
     */
    const activeCompanyProfile = useMemo(() => loggedInEmployee.setActiveCompanyProfile(companyId!), [loggedInEmployee.activeCompanyProfile, companyId])

    return activeCompanyProfile
}
